import styles from "./Spinner.module.scss";
import { Spinner as SpinnerNextUI } from "@nextui-org/react";

const Spinner = () => {
  const { spinnerWrapper, spinnerBase, circle1, circle2 } = styles;

  return (
    <div>
      <SpinnerNextUI
        classNames={{
          circle1: circle1,
          circle2: circle2,
          wrapper: spinnerWrapper,
          base: spinnerBase,
        }}
      />
    </div>
  );
};

export default Spinner;
